import styled, { css } from 'styled-components';

const FooterButtonContainer = styled.div`
  display: flex;
  width: 600px;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  flex-shrink: 0;
  z-index: 2;
  ${(props) =>
    !!props.withTopComponent &&
    css`
      padding: 16px;
      align-self: center;
    `};
`;
export default FooterButtonContainer;
